import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-import-files',
  templateUrl: './import-files.component.html',
  styleUrls: ['./import-files.component.scss']
})
export class ImportFilesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
